import type { CityConfig } from "../city-template/types";

export const grinnellConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Iowa HHS Vital Records (Birth, Death, Marriage)", url: "https://hhs.iowa.gov/vital-records", desc: "Official Iowa vital records office in Des Moines" },
    { icon: "ri-heart-pulse-line", label: "Poweshiek County Recorder — Marriage Licenses", url: "https://www.poweshiekcounty.org/recorder", desc: "Poweshiek County Recorder — marriage license issuance" },
    { icon: "ri-scales-line", label: "Iowa Courts — Divorce Records", url: "https://www.iowacourts.gov/", desc: "Iowa Judicial Branch — divorce decree records" },
    { icon: "ri-global-line", label: "VitalChek — Order Vital Records Online", url: "https://www.vitalchek.com/", desc: "Official partner of Iowa HHS for online vital record orders" },
  ],
  city: "Grinnell",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "grinnell",
  route: "/cities/grinnell",
  title: "Emergency Passport Grinnell, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Grinnell, IA — as fast as 24 hours. Serving Poweshiek County and Central Iowa. A+ BBB rated registered State Dept. courier serving Grinnell College community, medical professionals, and Central Iowa travelers. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Grinnell, IA",
  heroSubtitle: "Grinnell College semester abroad in London starting next week and no passport? Medical mission trip through Grinnell Regional and the clock is ticking? Conference in Toronto with a Grinnell Mutual delegation? We help Grinnell and Central Iowa residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Grinnell%20Iowa%20historic%20downtown%20with%20brick%20buildings%20Grinnell%20College%20campus%20green%20lawns%20and%20modern%20architecture%20in%20a%20small%20college%20town%20setting%20Central%20Iowa%20at%20golden%20hour%20warm%20sunlight%20vibrant%20late%20summer%20atmosphere&width=1800&height=700&seq=grinnell-hero-ia-2026&orientation=landscape",
  heroImageAlt: "Grinnell Iowa historic downtown and Grinnell College campus Central Iowa at golden hour",
  geoPosition: "41.7436;-92.7222",
  geoPlacename: "Grinnell, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, 9th Floor, Chicago, IL 60604",
    distance: "Located in the Chicago Loop — approximately 325 miles east of Grinnell via I-80",
  },
  nearbyCitiesZips: [
    { name: "Grinnell", zips: "50112" },
    { name: "Newton", zips: "50208" },
    { name: "Montezuma", zips: "50171" },
    { name: "Brooklyn", zips: "52211" },
    { name: "Pella", zips: "50219" },
    { name: "Knoxville", zips: "50138" },
    { name: "Oskaloosa", zips: "52577" },
    { name: "Marshalltown", zips: "50158" },
    { name: "Tama", zips: "52339" },
    { name: "Toledo", zips: "52342" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "West Des Moines", zips: "50265, 50266" },
    { name: "Ankeny", zips: "50021, 50023" },
    { name: "Ames", zips: "50010–50014" },
    { name: "Iowa City", zips: "52240–52246" },
    { name: "Cedar Rapids", zips: "52401–52411" },
    { name: "Altoona", zips: "50009" },
    { name: "Indianola", zips: "50125" },
    { name: "Coralville", zips: "52241" },
    { name: "Sigourney", zips: "52591" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Central Iowa departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Central Iowa Coverage", desc: "Serving Poweshiek, Jasper, Marion, and surrounding counties" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Fast passport renewal in West Des Moines, IA", route: "/cities/west-des-moines" },
    { name: "Emergency passport help in Pella, IA", route: "/cities/pella" },
    { name: "Urgent passport services in Iowa City, IA", route: "/cities/iowa-city" },
    { name: "Same-day passport help in Ames, IA", route: "/cities/ames" },
    { name: "Passport courier services in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Grinnell remotely via secure courier. We do not have a walk-in office in Grinnell — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Poweshiek County and the entire Central Iowa region.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Poweshiek County and the Central Iowa region including Jasper, Marion, Marshall, and Tama counties",
  serviceAreaIntro: "From Grinnell College's academic community with its study abroad programs to Grinnell Regional Medical Center with its medical mission trips, from Grinnell Mutual Reinsurance with frequent business travel to the historic downtown brick buildings on Main Street, from the farm communities of rural Poweshiek County to the I-80 corridor connecting Central Iowa — Fast Passport Center serves the entire Grinnell region. We regularly help travelers from Grinnell, Newton, Montezuma, and Brooklyn get their passports fast without the 5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Grinnell neighborhoods and the surrounding Central Iowa area including Newton, Montezuma, Brooklyn, Pella, Knoxville, Oskaloosa, Marshalltown, and Tama. If you are anywhere in Poweshiek County, Jasper County, or the Central Iowa region, we have you covered.",
  howItWorksIntro: "Most Grinnell travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Central Iowa travelers often face a 5-plus-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Grinnell and Poweshiek County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Grinnell? Here are the most common ones we hear from Central Iowa travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Grinnell travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Professor James L.",
      location: "Grinnell, IA",
      rating: 5,
      text: "Grinnell College sabbatical to Oxford with 8 days notice — my passport was expired. Fast Passport Center renewed it in 2 days. My department chair was shocked. Three other faculty used them after me.",
      service: "Passport Renewal",
    },
    {
      name: "Claire R.",
      location: "Grinnell, IA",
      rating: 5,
      text: "Medical mission through Grinnell Regional to Guatemala — my passport had been expired for years. Fast Passport Center got it in 3 days. I would have missed the entire trip without them.",
      service: "New Passport",
    },
    {
      name: "David and Kim M.",
      location: "Brooklyn, IA",
      rating: 5,
      text: "Anniversary trip to Paris booked and our passports expired. Fast Passport Center got both renewed in 4 days. We made our flight with time to spare. Best anniversary gift ever — peace of mind!",
      service: "Passport Renewal",
    },

  ],
  facilities: [
    {
      id: "grinnell-1",
      name: "Grinnell Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "921 4th Ave",
      city: "Grinnell",
      state: "IA",
      zip: "50112",
      phone: "(641) 236-7531",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Grinnell",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Grinnell facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "grinnell-2",
      name: "Poweshiek County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "302 E Main St",
      city: "Montezuma",
      state: "IA",
      zip: "50171",
      phone: "(641) 623-5176",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "15 miles south of Grinnell",
      website: "https://www.poweshiekcounty.org/recorder",
      websiteLabel: "Poweshiek County Recorder",
      notes: "Accepts passport applications. Good alternative with extended county office hours.",
      icon: "ri-government-line",
    },
    {
      id: "grinnell-3",
      name: "Newton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 1st Ave E",
      city: "Newton",
      state: "IA",
      zip: "50208",
      phone: "(641) 792-4211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles west of Grinnell",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Jasper County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "grinnell-4",
      name: "Marshalltown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 S 3rd Ave",
      city: "Marshalltown",
      state: "IA",
      zip: "50158",
      phone: "(641) 752-4261",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles northwest of Grinnell",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Marshall County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "grinnell-5",
      name: "Pella Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "703 Main St",
      city: "Pella",
      state: "IA",
      zip: "50219",
      phone: "(641) 628-4021",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles south of Grinnell",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Marion County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "grinnell-6",
      name: "Iowa Valley Community College — Grinnell",
      type: "Community College Passport Acceptance",
      address: "123 6th Ave W",
      city: "Grinnell",
      state: "IA",
      zip: "50112",
      phone: "(641) 236-0513",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Grinnell campus",
      website: "https://www.iowavalley.edu/",
      websiteLabel: "Iowa Valley CC",
      notes: "Serves Iowa Valley Community College students and staff. Call for passport acceptance hours.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Central Iowa photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Poweshiek County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Grinnell applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Grinnell College families at the county clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Grinnell travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Grinnell." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Grinnell address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Grinnell before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Grinnell for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-plus-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Grinnell?", a: "Fast Passport Center offers fast passport renewal in Grinnell in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Grinnell?", a: "The nearest regional passport agency to Grinnell is the Chicago Passport Agency, approximately 325 miles east via I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Grinnell without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Grinnell?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5-plus hours from Grinnell — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Poweshiek County and Central Iowa residents." },
    { q: "Do you serve the entire Central Iowa region?", a: "Absolutely. Fast Passport Center serves the entire Central Iowa region including Grinnell, Newton, Montezuma, Brooklyn, Pella, Marshalltown, and surrounding communities. Our courier service works seamlessly from any address in Poweshiek County, Jasper County, and Central Iowa." },
    { q: "Can I expedite a child passport in Grinnell?", a: "Yes. Fast Passport Center expedites child passports in Grinnell for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Central Iowa families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Grinnell with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart — Grinnell", address: "1310 W St S, Grinnell, IA 50112", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Grinnell", address: "1030 Main St, Grinnell, IA 50112", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Newton", address: "300 Iowa Speedway Dr, Newton, IA 50208", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Pella", address: "1202 Washington St, Pella, IA 50219", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Des Moines", address: "3400 SE 14th St, Des Moines, IA 50320", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "FedEx Office — West Des Moines", address: "6305 Mills Civic Pkwy, West Des Moines, IA 50266", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Grinnell Driver's License",
      address: "220 4th Ave W, Grinnell, IA 50112",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Poweshiek County. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Newton Driver's License",
      address: "2112 S 24th Ave W, Newton, IA 50208",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Jasper County. REAL ID available.",
      featured: false,
    },
    {
      name: "Iowa DOT — Marshalltown Driver's License",
      address: "3408 S Center St, Marshalltown, IA 50158",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Marshall County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "60 miles west of Grinnell",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Iowa's largest airport with direct flights nationwide. About 1 hour from Grinnell.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: true,
    },
    {
      code: "CID",
      name: "Eastern Iowa Airport",
      distance: "80 miles east of Grinnell",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Serves Cedar Rapids and Eastern Iowa. About 1 hour 15 minutes from Grinnell.",
      flightUrl: "https://www.eiairport.org/",
      flightLabel: "CID Airport",
      featured: false,
    },
    {
      code: "MPZ",
      name: "Mount Pleasant Municipal Airport",
      distance: "95 miles southeast of Grinnell",
      address: "2200 S Iris Rd, Mt Pleasant, IA 52641",
      note: "Regional airport with general aviation services. About 1 hour 30 minutes from Grinnell.",
      flightUrl: "https://www.cityofmountpleasantiowa.us/",
      flightLabel: "MPZ Airport",
      featured: false,
    },
  ],
};